import { render, staticRenderFns } from "./setYear.vue?vue&type=template&id=5becba48&scoped=true&"
import script from "./setYear.vue?vue&type=script&lang=js&"
export * from "./setYear.vue?vue&type=script&lang=js&"
import style0 from "./setYear.vue?vue&type=style&index=0&id=5becba48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5becba48",
  null
  
)

export default component.exports